import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import styled, { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { USER_ROLES } from './constants/roles';
import GlobalStyles from './GlobalStyles';
import Header from './components/Header';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import Landing from './pages/Landing';
import FindHustle from './pages/FindHustle';
import ShareHustle from './pages/ShareHustle';
import FindGig from './pages/FindGig';
import ShareGig from './pages/ShareGig';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import VentureDetail from './pages/VentureDetail';
import Profile from './pages/Profile';
import Messages from './pages/Messages';
import Login from './pages/Login';
import Register from './pages/Register';
import AdminModeration from './pages/AdminModeration';
import Unauthorized from './pages/Unauthorized';
import TermsAndConditions from './pages/TermsAndConditions';
import './App.css';

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: ${props => props.theme.colors.background};
  transition: background-color 0.3s ease;
`;

const AppContent = () => {
  const { theme } = useTheme();
  
  return (
    <StyledThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <AppContainer>
          <Header />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/find-hustle" element={<FindHustle />} />
            <Route path="/share-hustle" element={
              <ProtectedRoute requireRole={USER_ROLES.ENTREPRENEUR}>
                <ShareHustle />
              </ProtectedRoute>
            } />
            <Route path="/find-gig" element={<FindGig />} />
            <Route path="/share-gig" element={
              <ProtectedRoute requireRole={USER_ROLES.ENTREPRENEUR}>
                <ShareGig />
              </ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute requireRole={USER_ROLES.ADMIN}>
                <AdminModeration />
              </ProtectedRoute>
            } />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/venture/:id" element={<VentureDetail />} />
            <Route path="/profile" element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } />
            <Route path="/messages" element={
              <ProtectedRoute>
                <Messages />
              </ProtectedRoute>
            } />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          </Routes>
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 3000,
              style: {
                background: theme.colors.primary,
                color: '#fff',
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: '#fff',
                  secondary: theme.colors.primary,
                },
              },
              error: {
                duration: 4000,
                iconTheme: {
                  primary: '#fff',
                  secondary: '#ef4444',
                },
              },
            }}
          />
          <Footer />
        </AppContainer>
      </Router>
    </StyledThemeProvider>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
